<template>
    <!-- 问答题 -->
    <div class="itemConte" >
        <h5 class="title flex">{{itmData.questionindex}}.<span v-html="itmData.subject"></span>（{{itmData.questiontypename+'，'+itmData.quesscore}}分）</h5>
        <p class="studentAnswer">学生回答：<span v-html="itmData.uselanswer"></span></p>
        <p class="studentAnswer">参考答案：<span v-html="itmData.referenceanswer"></span></p>
        <p v-if="itmData.quesanalysis" class="analysis">解析：<span v-html="itmData.quesanalysis"></span></p>
        <p v-else class="analysis">解析：暂无解析</p>
        <p v-if="!type" class="studentAnswer">最后评分：<span class="pf">{{itmData.userscore}}</span></p>
        <p v-if="!type" class="studentAnswer">批阅评语：<span >{{itmData.checkmemo}}</span></p>
        <div v-else>
            <div class="playFen">
                <span class="mr-10">打分</span>
                <el-input v-model="itmData.userscore" placeholder="评分"></el-input>
                <span class="ml-10">分</span>
            </div>
            <div class="flex mt-10">
                <span class="">评语：</span>
                <div class="UEditor">
                    <el-input v-model="itmData.checkmemo" type="textarea" placeholder="请输入内容"></el-input>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['itmData', 'type'],
    data(){
        return {
            
        }
    },
    methods: {

    }
}
</script>
<style lang="scss" scoped>
    .itemConte{
        padding: 10px;
        background: #f6f6f6;
        box-sizing: border-box;
        margin-bottom: 10px;
        .pf{
            color: #d51b1b;
        }
        .playFen{
            font-size: 14px;
            display: flex!important;
            align-items: center;
            >.el-input{
                width: 160px!important;
            }
        }
        .UEditor{
            width: 50%;
        }
        h5{
            font-size: 14px;
        }
        .fenNum{
            color: #666666;
        }
        .analysis{
            color: #666666;
            // margin: 20px;
        }
        .resBox{
            .res{
                .icon{
                    font-size: 16px;
                }
                .resIConErr{
                    color: #d51b1b;
                }
                .resIconOk{
                    color: #0cb760;
                }
                .hide{
                    visibility: hidden;
                }
                .resDesc{
                    color: #0cb760!important;
                }
            }
        }
    }

</style>